// import React, {useState} from 'react';
// import {
//     closestCenter,
//     DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors
// } from '@dnd-kit/core';
// import {
//     rectSwappingStrategy,
//     SortableContext,
//     sortableKeyboardCoordinates,
// } from '@dnd-kit/sortable';
// import {OverlayItem} from "./OverlayItem";
// import {stores} from "../../stores";
// import {SortableSelectorWrapper} from "./SortableSelectorWrapper";
// import "./SortableSelectors.css";

// export function SortableSelectorsList() {

//     const [ctrlKeyPressed, setCtrlKeyPressed] = useState(false);

//     function keyDown(e) {
//         setCtrlKeyPressed(e.ctrlKey || e.metaKey);
//     }
//     function keyUp(e) {
//         setCtrlKeyPressed(e.ctrlKey || e.metaKey);
//     }

//     const [activeId, setActiveId] = useState(null);
//     const [overId, setOverId] = useState(null);

//     const it = [];
//     for (let k=0; k<=stores.memory.getGlobalParamValue("MAX_PRESET"); k++) {
//         it.push(`${k}`);
//     }
//     const [items, setItems] = useState(it);

//     const sensors = useSensors(
//         useSensor(PointerSensor),
//         useSensor(KeyboardSensor, {
//             coordinateGetter: sortableKeyboardCoordinates,
//         })
//     );

//     function handleDragStart(event) {
//         const {active} = event;
//         setActiveId(active.id);
//     }

//     function handleDragMove(event) {
//     }

//     function handleDragOver(event) {
//         const {over} = event;
//         setOverId(over.id);
//     }

//     function handleDragEnd(event) {
//         const {active, over} = event;
//         setOverId(null);
//         if (active.id !== over.id) {

//             // we need to swap the items for the visual animation
//             const oldIndex = items.indexOf(active.id);
//             const newIndex = items.indexOf(over.id);
//             const tmp = items.slice();
//             tmp[oldIndex] = items[newIndex];
//             tmp[newIndex] = items[oldIndex];
//             setItems(tmp);

//             if (ctrlKeyPressed) {
//                 stores.memory.copyPreset(items.indexOf(active.id), items.indexOf(over.id));
//             } else {
//                 stores.memory.swapPresets(items.indexOf(active.id), items.indexOf(over.id));
//                 stores.midi.save(items.indexOf(active.id));
//             }
//             stores.midi.save(items.indexOf(over.id));

//             setCtrlKeyPressed(false);
//         }
//     }

//     // const strategy = verticalListSortingStrategy;
//     const strategy = rectSwappingStrategy;

//     return (
//         <div onKeyDown={keyDown} onKeyUp={keyUp} className="presets-list" style={{overflow: 'auto'}}>
//             <DndContext
//                 sensors={sensors}
//                 collisionDetection={closestCenter}
//                 onDragStart={handleDragStart}
//                 onDragMove={handleDragMove}
//                 onDragOver={handleDragOver}
//                 onDragEnd={handleDragEnd}>
//                 <SortableContext
//                     items={items}
//                     strategy={strategy}>
//                     {items.map((id, i) =>
//                             <SortableSelectorWrapper
//                                 presetNumber={i}
//                                 key={id}
//                                 id={id}
//                                 overed={ctrlKeyPressed && id === overId}
//                                 srcElement={i === items.indexOf(overId)}
//                                 ctrlKeyPressed={ctrlKeyPressed} />
//                     )}
//                 </SortableContext>
//                 <DragOverlay>
//                     {activeId ? <OverlayItem id={activeId} num={items.indexOf(activeId)} /> : null}
//                 </DragOverlay>
//             </DndContext>
//         </div>
//     );

// }

import React, { useState, useEffect } from 'react';
import {
    closestCenter,
    DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors
} from '@dnd-kit/core';
import {
    rectSwappingStrategy,
    SortableContext,
    sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import { OverlayItem } from "./OverlayItem";
import { stores } from "../../stores";
import { SortableSelectorWrapper } from "./SortableSelectorWrapper";
import "./SortableSelectors.css";
import { observer } from "mobx-react-lite";

export const SortableSelectorsList = observer(() => {
    const [ctrlKeyPressed, setCtrlKeyPressed] = useState(false);
    const [activeId, setActiveId] = useState(null);
    const [overId, setOverId] = useState(null);
    const [items, setItems] = useState([]);

    function keyDown(e) {
        setCtrlKeyPressed(e.ctrlKey || e.metaKey);
    }
    function keyUp(e) {
        setCtrlKeyPressed(e.ctrlKey || e.metaKey);
    }

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const showAll = stores.state.showAllPresets;
    // const maxPresets = stores.memory.getGlobalParamValue("MAX_PRESET");

    const deviceType = stores.memory.getDeviceType();
    const maxPreset = deviceType === "DPC-8EZ Gen3" ? 127 : 119;
    const minPreset = deviceType === "DPC-8EZ Gen3" ? 48 : 9;

    useEffect(() => {
        const max = showAll ? maxPreset : minPreset;
        const it = [];
        for (let k = 0; k <= max; k++) {
            it.push(`${k}`);
        }
        setItems(it);
    }, [showAll, minPreset, maxPreset]);

    function handleDragStart(event) {
        const { active } = event;
        setActiveId(active.id);
    }

    function handleDragOver(event) {
        const { over } = event;
        setOverId(over?.id || null);
    }

    function handleDragEnd(event) {
        const { active, over } = event;
        setOverId(null);
        if (active.id !== over?.id) {
            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);

            const newItems = [...items];
            newItems[oldIndex] = items[newIndex];
            newItems[newIndex] = items[oldIndex];
            setItems(newItems);

            if (ctrlKeyPressed) {
                stores.memory.copyPreset(oldIndex, newIndex);
            } else {
                stores.memory.swapPresets(oldIndex, newIndex);
                stores.midi.save(oldIndex);
            }
            stores.midi.save(newIndex);

            setCtrlKeyPressed(false);
        }
    }

    const strategy = rectSwappingStrategy;

    return (
        <div onKeyDown={keyDown} onKeyUp={keyUp} className="presets-list" style={{overflow: 'auto'}}>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}>
                <SortableContext
                    items={items}
                    strategy={strategy}>
                    {items.map((id, i) =>
                        <SortableSelectorWrapper
                            key={id}
                            presetNumber={i}
                            itemKey={id}
                            id={id}
                            overed={ctrlKeyPressed && id === overId}
                            srcElement={i === items.indexOf(overId)}
                            ctrlKeyPressed={ctrlKeyPressed} />
                    )}
                </SortableContext>
                <DragOverlay>
                    {activeId ? <OverlayItem id={activeId} num={items.indexOf(activeId)} /> : null}
                </DragOverlay>
            </DndContext>
        </div>
    );
});